import { render, staticRenderFns } from "./EditorAssignedProjectsPage.vue?vue&type=template&id=2cebef7e"
import script from "./EditorAssignedProjectsPage.vue?vue&type=script&lang=ts"
export * from "./EditorAssignedProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./EditorAssignedProjectsPage.vue?vue&type=style&index=0&id=2cebef7e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports